<ng-container *ngIf="isLoading; else learnings">
  <div class="l_flexbar">
    <span class="l_flex-grow">
      <div style="width: 10rem">
        <dgx-skeleton type="list" [rows]="1"></dgx-skeleton>
      </div>
    </span>
    <div class="l_flex-justify-right">
      <div style="width: 10rem">
        <dgx-skeleton type="list" [rows]="1"></dgx-skeleton>
      </div>
    </div>
  </div>
  <div class="guts-m-t-2">
    <dgx-skeleton
      *ngFor="let _ of [].constructor(20)"
      type="input-card"
      data-dgat="search-learnings-953"
    ></dgx-skeleton>
  </div>
</ng-container>

<ng-template #learnings>
  <div *ngIf="showSort" class="l_flexbar">
    <span class="par par--small par--light_a font-bold l_flex-grow">
      {{ resultsRange }}
    </span>

    <div
      class="par par--small par--light_a font-bold l_flex l_flex-justify-right"
    >
      {{ i18n.Core_SortBy }}
      <dgx-menu
        [menuConfig]="menuConfig"
        placement="bottom-right"
        class="guts-m-l-half"
      >
        <button
          type="button"
          attr.aria-label="{{ i18n.Core_SortBy }}: {{ sortButtonText | async }}"
          class="par par--small color-blue"
          data-dgat="search-learnings-724"
        >
          {{ sortButtonText | async }}
          <df-icon icon="chevron-down" size="small"></df-icon>
        </button>
      </dgx-menu>
    </div>
  </div>

  <ul class="guts-m-t-2">
    <li
      *ngFor="let result of results; index as i; trackBy: trackByFn"
      data-dgat="search-learnings-b1e"
    >
      <dgx-learning-resource-card
        [resource]="result"
        [searchTerm]="searchTerm"
        [shouldTrackItemClicked]="false"
        (inputSelected)="onInputSelected($event, i)"
        [attr.data-id]="trackByFn(i, result)"
      ></dgx-learning-resource-card>
    </li>
  </ul>

  <div class="center-text" *ngIf="showPagination">
    <dgx-pagination
      [(page)]="pageNum"
      [collectionSize]="totalContentResults"
      [boundaryLinks]="true"
      [ellipses]="false"
      [maxSize]="8"
      [pageSize]="numResultsPerPage"
      [rotate]="true"
      (pageChange)="pageChange.emit($event)"
    >
    </dgx-pagination>
  </div>

  <div class="guts-m-t-4-half" *ngIf="showNoResults">
    <dgx-search-no-results [searchTerm]="searchTerm"></dgx-search-no-results>
  </div>
</ng-template>
